<!-- <span class="subscription-management"> -->
     <!-- <div class="card py-1 border-radius-none" *ngIf="planInfo.isFreeTrial">
        <div class="flex flex-row flex-wrap  card-container  ">

            <div class="flex align-items-center justify-content-center m-2 flex-grow-1 ">
                <span *ngIf="!planInfo.isFreeTrial && 1==0">
                    <div class="font-bold text-lg">
                        You Have {{dayLeftInRenewal}} Days Left in for Renewal.
                    </div>
                </span>
            </div>

        </div>
    </div> -->
    <div class="grid">
        <div class="col">
            <div class="conn-card">
                <app-bizz-customer-personal-info></app-bizz-customer-personal-info>
            </div>
        </div>
    </div>

    <!-- Dashboard Grid Layout -->
    <div class="grid" style="margin-top: 2rem;">
        <!-- Registers & Locations Card -->
        <div class="col-12 md:col-6 lg:col-4">
            <div class="conn-card" style="height: 100%;">
                <h4 style="margin-top: 0; color: var(--bs-active-primary);">Registers & locations</h4>
                <p style="color: #999; font-size: 0.875rem; margin-bottom: 1.5rem;">Extra registers and locations are available on Plus and Premium.</p>
                <button pButton type="button" label="Upgrade to add" class="p-button-blue" style="width: 100%; margin-bottom: 1rem;" (click)="upgradePlan()"></button>
                <div style="margin-top: 1.5rem;">
                    <div style="display: flex; align-items: center; margin-bottom: 1rem;">
                        <i class="pi pi-desktop" style="font-size: 1.5rem; margin-right: 0.75rem;"></i>
                        <div>
                            <div style="font-weight: 600;">Registers</div>
                            <div style="font-size: 0.875rem; color: #999;">1 included with Free</div>
                        </div>
                        <div style="margin-left: auto; color: #999; font-size: 0.875rem;">No extras</div>
                    </div>
                    <div style="display: flex; align-items: center;">
                        <i class="pi pi-map-marker" style="font-size: 1.5rem; margin-right: 0.75rem;"></i>
                        <div>
                            <div style="font-weight: 600;">Locations</div>
                            <div style="font-size: 0.875rem; color: #999;">1 included with Free</div>
                        </div>
                        <div style="margin-left: auto; color: #999; font-size: 0.875rem;">No extras</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add-ons Card -->
        <div class="col-12 md:col-6 lg:col-4">
            <div class="conn-card" style="height: 100%;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                    <h4 style="margin: 0; color: var(--bs-active-primary);">Add-ons</h4>
                    <span style="background: #f0f0f0; padding: 0.25rem 0.75rem; border-radius: 1rem; font-size: 0.875rem;">0 of 2 active</span>
                </div>
                <p style="color: #999; font-size: 0.875rem; margin-bottom: 1.5rem;">Add-ons are available on Plus and Premium.</p>
                <button pButton type="button" label="Add" icon="pi pi-plus" class="p-button-outlined" style="width: 100%; margin-bottom: 1.5rem;" (click)="purchaseAddonHandler()"></button>

                <div style="border-top: 1px solid #eee; padding-top: 1rem;">
                    <div style="margin-bottom: 1.5rem;">
                        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.5rem;">
                            <div style="font-weight: 600;">Advanced Loyalty Program</div>
                        </div>
                        <div style="font-size: 0.875rem; color: #999; margin-bottom: 0.5rem;">Points, tiers and targeted rewards across all channels.</div>
                        <div style="font-weight: 600; color: var(--bs-active-primary);">$49.00/mo</div>
                    </div>
                    <div>
                        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.5rem;">
                            <div style="font-weight: 600;">Standard Customer App</div>
                        </div>
                        <div style="font-size: 0.875rem; color: #999; margin-bottom: 0.5rem;">Your own branded ordering app for iOS and Android.</div>
                        <div style="font-weight: 600; color: var(--bs-active-primary);">$199.00/mo</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Hardware Card -->
        <div class="col-12 md:col-6 lg:col-4">
            <div class="conn-card" style="height: 100%;">
                <h4 style="margin-top: 0; color: var(--bs-active-primary);">Hardware</h4>
                <p style="color: #999; font-size: 0.875rem; margin-bottom: 1.5rem;">One-time purchase, billed to your card on file.</p>
                <button pButton type="button" label="Add" icon="pi pi-plus" class="p-button-blue" style="width: 100%; margin-bottom: 1.5rem;"></button>

                <div style="background: #f9f9f9; padding: 1rem; border-radius: 0.5rem;">
                    <div style="display: flex; align-items: center; margin-bottom: 1rem;">
                        <i class="pi pi-desktop" style="font-size: 1.5rem; margin-right: 0.75rem; color: var(--bs-active-primary);"></i>
                        <div>
                            <div style="font-size: 0.875rem; color: #999;">Devices owned</div>
                            <div style="font-weight: 600; font-size: 1.25rem;">4</div>
                        </div>
                        <div style="margin-left: auto; text-align: right;">
                            <div style="font-size: 0.875rem; color: #999;">Purchased and active</div>
                            <div style="font-weight: 600; color: var(--bs-active-primary);">$4,380.00 purchased</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Tab-based Content (hidden by default) -->
    <div class="conn-grid-main create-product" style="margin-top: 2rem; display: none;">
        <h4>Subscription</h4>
        <div>
            <p-tabMenu #tab
                [model]="items"
                [activeItem]="activeItem"
                [scrollable]="true"
                (click)="onTabItemClick(tab)">
            </p-tabMenu>

            <div *ngIf="activeItem?.label === 'Subscription'" class="fadeinright animation-duration-200 mt-3">
                <div class="conn-card">
                    <div class="conn-grid ">
                        <app-subscription
                            [planInfo]="planInfo"
                            [businessSetup]="businessSetup"
                        >
                        </app-subscription>
                        <div class="justify-content-end flex-wrap" *ngIf="!planInfo.isFreeTrial">
                            <div class="align-items-center justify-content-center m-2">
                                <button pButton type="button" label="Transfer" class="ml-4"
                                    (click)="transferBusinessRrquestForm()"></button>
                                    <button pButton type="button" label="Contact Support" class="ml-2"
                                    (click)="talkToExpertSupportGuy()"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="activeItem?.label == 'Billing Address' && !planInfo.isFreeTrial"
                class="fadeinright animation-duration-200 mt-3">
                <div class="conn-card">
                    <div class="conn-grid ">
                        <app-billing-address></app-billing-address>
                    </div>
                </div>
            </div>

            <div *ngIf="activeItem?.label == 'Billing History' && !planInfo.isFreeTrial" class="fadeinright animation-duration-200 mt-3">
                <div class="conn-card">
                    <div class="conn-grid ">

                        <app-billing-history></app-billing-history>
                    </div>
                </div>
            </div>
            <div *ngIf="activeItem?.label == 'Hardware' && !planInfo.isFreeTrial" class="fadeinright animation-duration-200 mt-3">
                <div class="conn-card">
                    <div class="conn-grid ">
                        <app-hardware-details-history></app-hardware-details-history>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <p-dialog header="Contact Support" [(visible)]="talkToSupportExpertForm" [blockScroll]="true"
    modal="true" [breakpoints]="{
        '960px': '80vw',
        '640px': '90vw',
        '250px': '100vw'
    }" [draggable]="false" [style]="{ width: '40vw' }">
    <ng-container>
        <br />
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Your Question
            </div>
            <div class="">
                <input type="text" [(ngModel)]="expertSupportQuestion" pInputText style="width: 100%;" />
            </div>
        </div>
        <div class="nas-grid-2x m-2">
            <div class="nas-label">Details
            </div>
            <div class="">
                <textarea [rows]="5" [cols]="30" [(ngModel)]="expertSupportMessage" pInputTextarea
                    style="width: 100%;">​</textarea>

            </div>
        </div>
    </ng-container>
    <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
            <button pButton type="button" label="Submit Request" class="ml-2" style="width: 160px"
                (click)="submitTalkExperGuyRequest()"></button>
        </div>
    </div>
</p-dialog>
<p-dialog header="Change Ownership Request " [(visible)]="businessTransferFormRequest" [blockScroll]="true"
modal="true" [breakpoints]="{
    '960px': '80vw',
    '640px': '90vw',
    '250px': '100vw'
}" [draggable]="false" [style]="{ width: '40vw' }">
<ng-container>
    <br />
    <div class="nas-grid-2x m-2">
        <div class="nas-label">Your Question
        </div>
        <div class="">
            <input type="text" [(ngModel)]="changerOwnerShipSubject" pInputText style="width: 100%;" />
        </div>
    </div>
    <div class="nas-grid-2x m-2">
        <div class="nas-label">Details
        </div>
        <div class="">
            <textarea [rows]="5" [cols]="30" [(ngModel)]="changerOwnerShipMessage" pInputTextarea
                style="width: 100%;">​</textarea>

        </div>
    </div>
</ng-container>
<div class="flex justify-content-end flex-wrap">
    <div class="flex align-items-center justify-content-center m-2">
        <button pButton type="button" label="Submit Request" class="ml-2" style="width: 160px"
            (click)="sendTransferBusinessRequest()"></button>
    </div>
</div>
</p-dialog>
